import StatisticsHeader from '../StatisticsHeader'
import AcademicTimeChart from './AcademicTimeChart'
import MostCommonFirstJobs from './MostCommonFirstJobs'
import PostgraduateStudies from './PostgraduateStudies'

const StatisticsAcademicPage = () => {
    return (
        <div className="w-full flex flex-col gap-6">
            <StatisticsHeader category="Formación académica" />
            <AcademicTimeChart />
            <PostgraduateStudies />
            <MostCommonFirstJobs />
        </div>
    )
}

export default StatisticsAcademicPage
